import { type ComponentPropsWithoutRef } from 'react';
import type { CategoryGroupInfoDto } from '@/api/gen/_model/categoryGroupInfoDto';
import { PublisherLabelMap, SchoolMapper } from '@/shared/category/util';
import { useSchoolInfoShortTranslation } from '@/shared/hooks/useSchoolInfoShortTranslation';
import { cn } from '@/utils/tailwind.util';
export const Chip = ({
  children,
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => {
  return <div className={cn('w-fit inline-flex px-xs py-3xs items-center justify-center text-body-sm-semibold text-neutral border border-alternative rounded-xs bg-default', className)} {...props} data-sentry-component="Chip" data-sentry-source-file="QuizInfoChip.tsx">
      {children}
    </div>;
};
export const PublisherChip = (props: {
  publisherId?: string;
  hideEtc?: boolean;
  className?: string;
}) => {
  if (!props.publisherId) return null;
  const PublisherLabel = PublisherLabelMap[props.publisherId];
  if (props.hideEtc && !PublisherLabel) {
    return null;
  }
  return <Chip className={props.className} data-sentry-element="Chip" data-sentry-component="PublisherChip" data-sentry-source-file="QuizInfoChip.tsx">
      {PublisherLabel || props.publisherId}
    </Chip>;
};
export const SchoolInfoChip = ({
  className,
  schoolInfo
}: {
  className?: string;
  schoolInfo: Omit<CategoryGroupInfoDto, 'subject' | 'subSubject'>;
}) => {
  const {
    schoolType: type,
    schoolSemester,
    schoolGrade
  } = schoolInfo;
  const {
    schoolTypeText,
    schoolSemesterText,
    schoolGradeText
  } = useSchoolInfoShortTranslation({
    schoolInfo
  });
  const schoolType = SchoolMapper.getSchoolTypeNameById(Number(type));
  const isShowSchoolGrade = Number(schoolGrade) && schoolGrade;
  const joinText = `${schoolTypeText}${isShowSchoolGrade ? ` ${schoolGradeText}` : ''}${schoolSemester ? `-${schoolSemesterText}` : ''}`;
  return <Chip className={cn('border-assistive bg-neutral', schoolType === 'high' && 'bg-pink-50 border-opacity-assistive', schoolType === 'middle' && 'bg-blue-50 border-opacity-assistive', schoolType === 'primary' && 'bg-green-50 border-opacity-assistive', className)} data-sentry-element="Chip" data-sentry-component="SchoolInfoChip" data-sentry-source-file="QuizInfoChip.tsx">
      <span>{joinText}</span>
    </Chip>;
};